import "./Terms.module.css";
import Header from "@/reusable_sections/Header";
import TRminosYCondiciones from "./sections/TRminosYCondiciones";
import Footer from "@/reusable_sections/Footer";
export default function TermsPage() {
  return <div>
      <Header />
      <TRminosYCondiciones />
      <Footer />
    </div>;
}